<template>
    <label class="checkbox-label">
        <input
            v-model="fieldValue"
            type="checkbox"
            class="checkbox"
            autocomplete="off"
            style="display:none"
        />
        <span v-html="fieldLabel"></span>
        <span class="checkmark"></span>
        <span class="pl-5">{{placeholder}}</span>
    </label>
</template>

<script>
export default {
    props: {
        value: Boolean,
        labelTranslate: String,
        label: String,
        linkWord: Object,
        placeholder: String,
    },
    computed: {
        fieldValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        fieldLabel() {
            if (this.linkWord) {
                let result = '';

                for (let i = 0; i < this.linkWord.words.length; i++) {
                    if (
                        this.$t(this.labelTranslate).match(
                            this.linkWord.words[i]
                        )
                    ) {
                        result = this.$t(this.labelTranslate).replace(
                            this.linkWord.words[i],
                            `<a href="${this.linkWord.link}">${this.linkWord.words[i]}</a>`
                        );
                    }
                }
                return result;
            }
            return this.$t(this.labelTranslate) || this.label;
        },
    },
};
</script>

<style lang="scss">
.checkbox-label {
    padding-left: 40px;
    cursor: pointer ;
    display: inline-block;
    position: relative;
    .checkmark {
        box-sizing: border-box;

        position: absolute;
        width: 24px;
        height: 24px;
        left: 0px;
        top: 0px;

        
        border: 2px solid var(--v-primary-base);
        border-radius: 8px;
    }

    .checkbox:checked ~ .checkmark {
        background:  var(--v-primary-base);
    }
    
    .checkbox:checked ~ .checkmark:after {
        content: "✓";
        position: absolute;
        width: 15px;
        height: 23px;
        left: 3px;

        font-family: 'PF BeauSans Pro';
        font-style: normal;
        font-weight: 500;
        font-size: 19px;
        line-height: 23px;

        color: #FFFFFF;
    }

}

</style>
